export default __webpack_public_path__ + "static/media/notFoundSearch.792218ef.svg";